import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { useSectionData } from '../hooks/useFirebaseData';
import DescriptionSkeleton from './ui/DescriptionSkeleton';

const RoundedImage = styled('img')({
    width: '350px',
    maxWidth: '350px',
    height: '270px',
    borderRadius: '5%',
    objectFit: 'cover',
});

const Philosophy = () => {
    const {
        data: philosophyData,
        loading,
        error,
    } = useSectionData("philosophy", "philosophy");
    

    if (loading) {
        return (
           <DescriptionSkeleton/>
        );
    }

    if (error) {
        return (
            <Box sx={{ 
                paddingY: 5, 
                px: { xs: 2, md: 5 },
                textAlign: 'center' 
            }}>
                <Typography sx={{ color: 'error.main' }}>
                    データの読み込み中にエラーが発生しました
                </Typography>
            </Box>
        );
    }
    

    if (!philosophyData) {
        return null;
    }
    
    return (
        <Box
            sx={{
                paddingY: 5,
                px: { xs: 2, md: 5 },
                flexDirection: 'column',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    gap: 4,
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                }}
            >
                <Box
                    flexGrow={1}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    padding={2}
                >
                    {/* Use Firebase image */}
                    <RoundedImage 
                        src={philosophyData.image} 
                        alt="Personal Gym" 
                        onError={(e) => {
                            e.target.style.display = 'none';
                        }}
                    />
                </Box>

                <Box
                    flexGrow={1}
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="flex-start"
                    px={{ xs: 2, md: 5 }}
                >
                    <Typography
                        variant="h5"
                        sx={{
                            color: '#E87F11',
                            fontWeight: 'bold',
                            marginBottom: 1,
                            fontSize: {
                                xs: '1.75rem',
                                md: '2rem',
                            },
                        }}
                    >
                        {philosophyData.title}
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            color: '#E87F11',
                            lineHeight: 1.6,
                            fontSize: {
                                xs: '1rem',
                                md: '1.25rem',
                            },
                            whiteSpace: 'pre-line'
                        }}
                    >
                        {philosophyData.mainContent}
                    </Typography>
                </Box>
            </Box>

            <Box px={{ xs: 2, md: 5 }} marginTop={1}>
                <Typography
                    variant="body1"
                    sx={{
                        color: '#E87F11',
                        lineHeight: 1.6,
                        fontSize: {
                            xs: '1rem',
                            md: '1.25rem',
                        },
                        whiteSpace: 'pre-line'
                    }}
                >
                    {philosophyData.bottomContent}
                </Typography>
            </Box>
        </Box>
    );
};

export default Philosophy;